import PropTypes from 'prop-types';

import AcademyInfo from '../AcademyInfo/AcademyInfo';
import ComplementaryInfo from '../ComplementaryInfo/ComplementaryInfo';
import UserInfo from '../UserInfo/UserInfo';
import classes from './CourseTop.module.css';

const CourseTop = props => {
  return (
    <aside className={classes.courseTopContainer}>
      <div className={classes.courseInfoContainer}>
        <AcademyInfo
          data={props.dataCourse.data}
          userAditionalTrack={props.dataCourse.userAditionalTrack}
          lessons={props.dataCourse.lessonsCourse}
          accessCourse={props.dataCourse.accessCourse}
        />
        <ComplementaryInfo
          data={props.dataCourse.data}
          aditionalData={props.dataCourse.aditionalData}
          usersInCourse={props.dataCourse.usersInCourse}
        />
        <UserInfo />
      </div>
    </aside>
  );
};

CourseTop.propTypes = {
  // eslint-disable-next-line react/require-default-props
  dataCourse: PropTypes.object
};

export default CourseTop;
